import hasWindow from './hasWindow';

const modifyShellAffixClass = (action, selector, className) => {
  if (!hasWindow()) {
    return;
  }

  const shellElement = window.document.querySelector(selector);

  if (shellElement && shellElement.classList) {
    shellElement.classList[action](className);
  }
};

export const addClassToElement = (selector, className) =>
  modifyShellAffixClass('add', selector, className);
export const removeClassFromElement = (selector, className) =>
  modifyShellAffixClass('remove', selector, className);
